/**
 * Route for `react-native-sdk`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReactNativeSdkPage } from "../features/react-native-sdk/ReactNativeSdkPage";

export const reactNativeSdkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/react-native-sdk",
	component: ReactNativeSdkPage,
});

export default reactNativeSdkRoute;
